import { EAccountPlansType } from "../../Enum/EAccountPlansType"
import { ECommercialOriginType } from "../../Enum/ECommercialOriginType"
import { EPaymentProcessingSeverityType as EPaymentProcessingSeverityType } from "../../Enum/EPaymentProcessingSeverityType"

export class AdminSubscriptionCase {
  subscriptionId: number

  companyId: number

  companyName: string

  ownerPhone: string

  ownerEmail: string

  createdAt?: string

  isTestOrDemoCompany: boolean

  planType: EAccountPlansType

  subscriptionStatus: string

  statusDetail?: string

  lastPaymentStatus: string

  lastPaymentDate?: string

  lastPaymentAmount?: number

  currentChargeAmount: number

  nextPaymentDate?: string

  processingSeverity: EPaymentProcessingSeverityType

  supportRequestsCount: number

  canManualActivate: boolean

  commercialOriginType: ECommercialOriginType

  salesRepresentativeName?: string

  commercialReferralCode?: string

  providerName?: string

  commercialSourceDescription?: string

  isCommissionEligible: boolean

  commissionPercentage?: number

  constructor(data: Partial<AdminSubscriptionCase> = {}) {
    this.subscriptionId = data.subscriptionId ?? 0

    this.companyId = data.companyId ?? 0

    this.companyName = data.companyName ?? ""

    this.ownerPhone = data.ownerPhone ?? ""

    this.ownerEmail = data.ownerEmail ?? ""

    this.createdAt = data.createdAt

    this.isTestOrDemoCompany = data.isTestOrDemoCompany ?? false

    this.planType = data.planType ?? EAccountPlansType.None

    this.subscriptionStatus = data.subscriptionStatus ?? ""

    this.statusDetail = data.statusDetail

    this.lastPaymentStatus = data.lastPaymentStatus ?? ""

    this.lastPaymentDate = data.lastPaymentDate

    this.lastPaymentAmount = data.lastPaymentAmount

    this.currentChargeAmount = data.currentChargeAmount ?? 0

    this.nextPaymentDate = data.nextPaymentDate

    this.processingSeverity = data.processingSeverity ?? EPaymentProcessingSeverityType.None

    this.supportRequestsCount = data.supportRequestsCount ?? 0

    this.canManualActivate = data.canManualActivate ?? false

    this.commercialOriginType = data.commercialOriginType ?? ECommercialOriginType.Undefined

    this.salesRepresentativeName = data.salesRepresentativeName

    this.commercialReferralCode = data.commercialReferralCode

    this.providerName = data.providerName

    this.commercialSourceDescription = data.commercialSourceDescription

    this.isCommissionEligible = data.isCommissionEligible ?? false

    this.commissionPercentage = data.commissionPercentage
  }
}
